import ApiService from '../../utils/ApiService';
import Urls from '../../utils/Urls';
import * as Func from '../../utils/functions';
import {removeObjectNull} from "../../utils/functions";
import CompanyResponse, {MasterCompanyResponse} from "../mapping/Response/CompanyResponse";
import moment from "moment";

export function getListCompany(params) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.COMPANY_LIST,
        params: params,
        parser: dataParser,
    }).get();
}

export function masterData() {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.COMPANY_MASTER_DATA,
        // params: removeObjectNull({ city_id }),
        parser: data => new MasterCompanyResponse(data.data.result).exportMaster(),
    }).get();
}

export function create(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.COMPANY_CREATE,
    }).post(data);
}

export function update(data) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.COMPANY_UPDATE,
        endpointParams: {id: data?.id},
    }).put(data);
}

export function getItem(id) {
    return new ApiService({
        baseURL: process.env.REACT_APP_API_URL,
        endpoint: Urls.COMPANY_GET_ITEM,
        endpointParams: {id},
        parser: data => new CompanyResponse(data.data.result).exportItem(),
    }).get();
}

function dataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new CompanyResponse(item).exportList()),
        total_page: Math.ceil(parseInt(data.data.total) / parseInt(data.data.page_size))
    }
}
